import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import moment from 'moment';

import 'ds-shared-lib/src/components/ki-ds-graph-wrapper/ki-ds-graph-wrapper';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import style from './ki-ds-pwa-graph-container.css';
import '../ki-ds-pwa-graph-wrapper/ki-ds-pwa-graph-wrapper';

const CLASS_NAME = 'ki-ds-pwa-graph-container';

@customElement(CLASS_NAME)
class KiDsPwaGraphContainer extends KiDsPwaComponent {
    static styles = style;

    constructor() {
        super();
        this.currentMetaList = [];
        this.setTimeRange();
    }

    static get properties() {
        return {
            tsIdList: { type: Array },
            currentMetaList: { type: Array },
            from: { type: Object },
            until: { type: Object },
            period: { type: Object },
        };
    }

    setTimeRange() {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const hasFrom = params.has('from');
        const hasTo = params.has('to');
        const hasPeriod = params.has('period');
        const dateFormat = 'YYYY-MM-DD HH:mm:ss';

        if (hasFrom && hasTo) {
            this.until = params.get('to');
            this.from = params.get('from');
        } else {
            const period = hasPeriod ? params.get('period') : 'P7D';
            if (hasFrom) {
                this.from = params.get('from');
                this.until = moment(this.from).add(moment.duration(period)).format(dateFormat);
            } else {
                this.until = hasTo ? params.get('to') : moment();
                this.from = moment(this.until).subtract(moment.duration(period)).format(dateFormat);
            }
        }
    }

    render() {
        return html`
            <ki-ds-pwa-graph-wrapper
                .params=${{ userTimeZone: this.locale }}
                .from=${this.from}
                .until=${this.until}
                .timeSeries=${this.tsIdList}
                .timeSeriesMetadata=${this.currentMetaList}
            ></ki-ds-pwa-graph-wrapper>
        `;
    }
}
